function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_19174",
  "data-name": "Path 19174",
  d: "M16.764,61H1.615A1.618,1.618,0,0,0,0,62.615V73.385A1.618,1.618,0,0,0,1.615,75H16.764a1.618,1.618,0,0,0,1.615-1.615V62.615A1.618,1.618,0,0,0,16.764,61Zm-.223,1.077L9.224,69.394l-7.38-7.317ZM1.077,73.162V62.833l5.186,5.142Zm.761.761,5.19-5.19,1.818,1.8a.538.538,0,0,0,.76,0l1.773-1.773,5.162,5.162ZM17.3,73.162,12.141,68,17.3,62.838Z",
  transform: "translate(0.1 -60.9)",
  fill: "#000000",
  stroke: "#000000",
  strokeWidth: 0.2
});

var SvgMailBig = function SvgMailBig(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18.579,
    height: 14.2,
    viewBox: "0 0 18.579 14.2",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMailBig, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail_big.b05f6598.svg";
export { ForwardRef as ReactComponent };